import {
  array,
  assign,
  Describe,
  nullable,
  object,
  optional,
  string,
} from 'superstruct';

import {
  AugmentedCreateEntityInput,
  AugmentedCreateLpBusinessEntityInput,
  AugmentedUpdateEntityInput,
  AugmentedUpdateLpBusinessEntityInput,
} from '@/types/schema';

import {
  commonCreateBusinessEntityProperties,
  commonCreateBusinessEntityTopLevelProperties,
  commonUpdateBusinessEntityEntityUpdateProperties,
  commonUpdateBusinessEntityProperties,
  commonUpdateBusinessEntityTopLevelProperties,
  keyPersonSchema,
} from './businessEntityTypes';
import {
  createInsurancePolicyInput,
  updateInsurancePolicyInput,
} from './insuranceTypes';
import {
  createAccountSchema,
  createEntityInput,
  principalWithOwnershipSchema,
  updateAccountSchema,
} from './types';
import { $getValidatedInput } from './utils';

const createLPSchema: Describe<AugmentedCreateLpBusinessEntityInput> = object({
  create: commonCreateBusinessEntityProperties,
  withOwners: optional(nullable(array(principalWithOwnershipSchema))),
  withKeyPeople: optional(nullable(array(keyPersonSchema))),
  withDesignerAccount: optional(nullable(createAccountSchema)),
});

const updateLPSchema: Describe<AugmentedUpdateLpBusinessEntityInput> = object({
  id: string(),
  update: commonUpdateBusinessEntityProperties,
  withOwners: optional(nullable(array(principalWithOwnershipSchema))),
  withKeyPeople: optional(nullable(array(keyPersonSchema))),
  updateDesignerAccount: optional(nullable(updateAccountSchema)),
  withPolicies: optional(nullable(array(createInsurancePolicyInput))),
  updatePolicies: optional(nullable(array(updateInsurancePolicyInput))),
});

export const createSchema: Describe<AugmentedCreateEntityInput> = assign(
  object({
    create: createEntityInput,
    withLpBusinessEntity: optional(nullable(createLPSchema)),
  }),
  commonCreateBusinessEntityTopLevelProperties
);

export const updateSchema: Describe<AugmentedUpdateEntityInput> = assign(
  object({
    id: string(),
    update: commonUpdateBusinessEntityEntityUpdateProperties,
    updateLpBusinessEntity: optional(nullable(updateLPSchema)),
  }),
  commonUpdateBusinessEntityTopLevelProperties
);

export function validateLPCreateInput(
  input: AugmentedCreateEntityInput
): AugmentedCreateEntityInput {
  return $getValidatedInput(input, createSchema, 'LP create');
}

export function validateLPUpdateInput(
  input: AugmentedUpdateEntityInput
): AugmentedUpdateEntityInput {
  return $getValidatedInput(input, updateSchema, 'LP update');
}
